import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, toast } from '@livable/saas-react-components';
import { Button, List, ListItem, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DEMO_PROPERTY_STEPS, APPFOLIO_PROPERTY_STEPS, PROPERTY_STEPS } from 'src/constants/property';
import { FEE_PROPERTY_TYPES } from 'src/constants/feesSetting';
import { useStore } from 'src/stores';
// import ACHProcessingFee from './ACHProcessingFee';
import { AdminFee } from './AdminFee';
// import ConvenienceFee from './ConvenienceFee';
import CustomFeeConfirmation from './CustomFeeConfirmation';
import { LateFee } from './LateFee';
// import NSF from './NSF';
// import { PaperStatementFee } from './PaperStatementFee';
// import VacancyCostRecovery from './VacancyCostRecovery';
import useStyles from './styles';
export const PropertyFeeStructurePageV2 = observer(props => {
  var _getPropertyFee, _getPropertyFee2, _getPropertyFee3, _getPropertyFee4, _getPropertyFee5, _getPropertyFee6;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const inProgress = store.properties.getPropertyFeesV2Async.inProgress || store.properties.updatePropertyFeesV2Async.inProgress || store.payment.getStripeProductsAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress;
  const buttonDisabled = !store.addNewProperty.feeStructureV2.feesValidation || inProgress || store.properties.updatePropertySetupProgressAsync.inProgress;
  // || store.addNewProperty.feeStructureV2.getPropertyFee({
  //   feeName: 'adminFee',
  // })?.value === 0

  const CURRENT_STEPS = store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS : PROPERTY_STEPS;
  const getPropertyFee = feeName => store.addNewProperty.feeStructureV2.getPropertyFee({
    feeName
  });
  const adminFee = ((_getPropertyFee = getPropertyFee('adminFee')) === null || _getPropertyFee === void 0 ? void 0 : _getPropertyFee.value) || null;
  const feeUnitType = ((_getPropertyFee2 = getPropertyFee('lateFee')) === null || _getPropertyFee2 === void 0 ? void 0 : _getPropertyFee2.feeUnitType) || '';
  const lateFee = ((_getPropertyFee3 = getPropertyFee('lateFee')) === null || _getPropertyFee3 === void 0 ? void 0 : _getPropertyFee3.value) || null;
  const initialAdminFee = (_getPropertyFee4 = getPropertyFee('initialAdminFee')) === null || _getPropertyFee4 === void 0 ? void 0 : _getPropertyFee4.value;
  const initialLateFee = (_getPropertyFee5 = getPropertyFee('initialLateFee')) === null || _getPropertyFee5 === void 0 ? void 0 : _getPropertyFee5.value;
  const initialLateFeeType = (_getPropertyFee6 = getPropertyFee('initialLateFee')) === null || _getPropertyFee6 === void 0 ? void 0 : _getPropertyFee6.feeUnitType;
  const editMode = props.editMode,
    handleStep = props.handleStep,
    mutablePropertyId = props.mutablePropertyId,
    notCompletedPropertyId = props.notCompletedPropertyId,
    registerActionBack = props.registerActionBack,
    registerActionNext = props.registerActionNext;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    diff = _useState2[0],
    setDiff = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoaded = _useState4[0],
    setIsLoaded = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    trigger = _useState6[0],
    setTrigger = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isConfirmationOpen = _useState8[0],
    setIsConfirmationOpen = _useState8[1];
  const currentPropertyId = mutablePropertyId ? mutablePropertyId : notCompletedPropertyId ? notCompletedPropertyId : localStorage.getItem('livable_property_id');
  const getPropertyFeesV2 = async () => {
    try {
      setIsLoaded(false);
      await store.payment.getStripeProductsAsync.run();
      const resp = await store.properties.getPropertyFeesV2Async.run({
        applyToStore: true,
        applyToHomeDashboard: false,
        propertyId: currentPropertyId
      });
      setIsLoaded(true);
      return resp === null || resp === void 0 ? void 0 : resp.response;
    } catch (error) {
      console.log('Error', error);
    }
  };
  const updatePropertyFees = async _ref => {
    let fees = _ref.fees;
    try {
      const resp = await store.properties.updatePropertyFeesV2Async.run(_objectSpread({
        propertyId: currentPropertyId
      }, fees));
      return resp;
    } catch (error) {
      console.log('Error', error);
    }
  };
  const submitForm = async () => {
    const _await$Promise$all = await Promise.all([updatePropertyFees({
        fees: store.addNewProperty.feeStructureV2.getPropertyFees({
          feeNames: Object.keys(FEE_PROPERTY_TYPES)
        })
      })]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 1),
      resp = _await$Promise$all2[0];
    if (resp && resp !== null && resp !== void 0 && resp.isSuccessful) {
      if (!mutablePropertyId) {
        await store.properties.updatePropertySetupProgressAsync.run({
          propertyId: currentPropertyId,
          propertySetupStep: localStorage.getItem('livable_demo_mode') !== 'Demo' ? Object.keys(CURRENT_STEPS).find(key => CURRENT_STEPS[key] === CURRENT_STEPS.FeeSetup) : Object.keys(DEMO_PROPERTY_STEPS).find(key => DEMO_PROPERTY_STEPS[key] === DEMO_PROPERTY_STEPS.FeeSetup)
        });
        if (localStorage.getItem('livable_demo_mode') !== 'Demo') {
          store.addNewProperty.changeCompletedStep(CURRENT_STEPS.PayoutDetails);
          handleStep(CURRENT_STEPS.PayoutDetails)();
        } else {
          store.addNewProperty.changeCompletedStep(DEMO_PROPERTY_STEPS.UtilityConfiguration);
          handleStep(DEMO_PROPERTY_STEPS.UtilityConfiguration)();
        }
      } else {
        setTrigger(!trigger);
        store.addNewProperty.feeStructureV2.initAfterLoadState();
      }
      if (mutablePropertyId) {
        setIsConfirmationOpen(false);
        toast('success', {
          body: ['Successfully saved']
        });
      }
    }
  };
  useEffect(() => {
    getPropertyFeesV2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);
  useEffect(() => {
    var _getPropertyFee7, _getPropertyFee8, _getPropertyFee9, _getPropertyFee0;
    setDiff(+adminFee !== ((_getPropertyFee7 = getPropertyFee('initialAdminFee')) === null || _getPropertyFee7 === void 0 ? void 0 : _getPropertyFee7.value) || +lateFee !== ((_getPropertyFee8 = getPropertyFee('initialLateFee')) === null || _getPropertyFee8 === void 0 ? void 0 : _getPropertyFee8.value) || ((_getPropertyFee9 = getPropertyFee('initialLateFee')) === null || _getPropertyFee9 === void 0 ? void 0 : _getPropertyFee9.feeUnitType) !== ((_getPropertyFee0 = getPropertyFee('lateFee')) === null || _getPropertyFee0 === void 0 ? void 0 : _getPropertyFee0.feeUnitType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminFee, feeUnitType, lateFee]);
  useEffect(() => {
    if (registerActionBack !== undefined) registerActionBack(() => {
      handleStep(store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS.UnitSetup : PROPERTY_STEPS.PropertyInformation)();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionBack]);
  useEffect(() => {
    if (registerActionNext !== undefined) registerActionNext(() => {
      submitForm();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionNext]);
  const handleModalClose = () => {
    setIsConfirmationOpen(false);
    store.addNewProperty.feeStructureV2.updateFee({
      feeName: 'adminFee',
      value: initialAdminFee
    });
    store.addNewProperty.feeStructureV2.updateFee({
      feeName: 'lateFee',
      feeUnitType: initialLateFeeType,
      value: initialLateFee
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.fee_structure')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.fee_structure_description'))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(AdminFee, {
    adminFee: adminFee,
    isLoaded: isLoaded
  }), !store.company.companyFeatureStore.disableLateFee && /*#__PURE__*/React.createElement(LateFee, null))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: inProgress
  })), store.payment.stripeProducts.length > 0 && !store.company.companyFeatureStore.disableSystemFee && /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.resident_paid_fees')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.resident_paid_fees_desc'))), /*#__PURE__*/React.createElement("div", {
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(List, {
    variant: "white"
  }, store.payment.stripeProducts.map(product => {
    var _store$homeDashboardS;
    if (product.name === 'Unit Subscription Fee' || (store.company.companyFeatureStore.disablePaperStatementFee || (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS !== void 0 && (_store$homeDashboardS = _store$homeDashboardS.companyFeatureSet) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.disablePaperStatementFee) && (product.name === 'Paper Statement' || product.name === 'Paper Invitation')) return;
    return /*#__PURE__*/React.createElement(ListItem, {
      key: product.name
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, product.name, ":", ' ', product.feeUnitType === 'Percentage' ? "".concat(product.defaultAmount, "%") : "$".concat(product.defaultAmount)), /*#__PURE__*/React.createElement("div", {
      className: classes.xsSection
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, t("add_new_property_flow.system_fee_".concat(product.name.split(' ').join('_').toLowerCase()))))));
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: inProgress
  })), !editMode && registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleStep(
    // localStorage.getItem('livable_demo_mode') !== 'Demo'
    // ? PROPERTY_STEPS.ContactInformation
    store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS.UnitSetup : PROPERTY_STEPS.PropertyInformation),
    variant: "text",
    disabled: store.properties.getPropertyFeesV2Async.inProgress || store.properties.updatePropertyFeesV2Async.inProgress || store.payment.getStripeProductsAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress,
    'custom-attribute': '101-property-fee-structure'
  }, t('general.back'), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, ': ', t('add_new_property_flow.property_information'))), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "priority",
    disabled: !store.addNewProperty.feeStructureV2.feesValidation || store.properties.getPropertyFeesV2Async.inProgress || store.properties.updatePropertyFeesV2Async.inProgress || store.payment.getStripeProductsAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress
    // store.addNewProperty.feeStructureV2.getPropertyFee({
    //   feeName: 'adminFee',
    // })?.value === 0
    ,
    onClick: submitForm,
    'custom-attribute': '102-property-fee-structure'
  }, store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, t('buttons.confirm'), ". ", t('general.next')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, t('general.next'), ":", ' ', localStorage.getItem('livable_demo_mode') !== 'Demo' ? t('subscriptions.payment_information') : t('add_new_property_flow.utilities_setup')))), editMode && /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, diff ? /*#__PURE__*/React.createElement(CustomFeeConfirmation, {
    customTrigger: /*#__PURE__*/React.createElement(Button, {
      size: "large",
      variant: "priority",
      'custom-attribute': '103-property-fee-structure'
    }, t('team_page.add_new_team_member')),
    disabled: buttonDisabled,
    handleModalClose: handleModalClose,
    handleModalOpen: () => setIsConfirmationOpen(true),
    isOpen: isConfirmationOpen,
    submitForm: submitForm
  }) : /*#__PURE__*/React.createElement(Button, {
    disabled: buttonDisabled,
    onClick: submitForm,
    type: "button",
    variant: "priority",
    'custom-attribute': '104-property-fee-structure'
  }, t('buttons.save'))));
});